/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Monitoring API
 * Monitoring API for working with device errors
 *
 * The version of the OpenAPI document: 1.20.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    DevicePivotIncidents,
    UnexpectedResetState,
} from './';

/**
 * Device state and incidents
 * @export
 * @interface Device
 */
export interface Device {
    /**
     * @type {string}
     * @memberof Device
     */
    device_id: string;
    /**
     * @type {UnexpectedResetState}
     * @memberof Device
     */
    last_unexpected_reset?: UnexpectedResetState;
    /**
     * @type {Date}
     * @memberof Device
     */
    last_update_time: Date;
    /**
     * @type {DevicePivotIncidents}
     * @memberof Device
     */
    incidents?: DevicePivotIncidents;
    /**
     * @type {string}
     * @memberof Device
     */
    trace_id: string;
}
